import React from "react";
import TitlePage from "../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Fieldset} from "primereact/fieldset";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import Paper from "@material-ui/core/Paper";
import {InputText} from "primereact/inputtext";

const User = ({headerUser}) => {
    return (
        <React.Fragment>
            <Paper elevation={5}
                   style={{paddingTop: '2%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TitlePage title="Usuarios"/>
                    </Grid>
                    <Grid item xs={12}>
                        <Fieldset legend="Filtros" toggleable={true} collapsed={true}>
                            <Grid container direction="row" justify="space-evenly" alignItems="center">
                                <Grid item>
                                    <label htmlFor="cb1" className="p-checkbox-label">Contrato</label>
                                    &nbsp;
                                    <InputText/>
                                </Grid>
                                <Grid item>
                                    <Grid container spacing={1}>
                                        <Grid item>
                                            <Button label="Limpiar"/>
                                        </Grid>
                                        <Grid item>
                                            <Button label="Buscar"/>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Fieldset>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            header={headerUser}
                            responsive={true}>
                            <Column field="contrato" header="Contrato"/>
                            <Column field="emisora" header="Emisora"/>
                            <Column field="serie" header="Serie"/>
                            <Column field="cupon" header="Cupon"/>
                            <Column field="isin" header="ISIN"/>
                            <Column field="tipoValor" header="Tipo Valor"/>
                            <Column field="cantidad" header="Títulos"/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>
        </React.Fragment>
    )
};

export default User;